export const LINEAL_CHANNELS_TTL = 'linealChannelsTTL';
export const EPG_VERSION_TTL = 'epgVersionTTL';
export const FAVORITED_LIVE_TTL = 'favoritedLiveTTL';
export const STATUS_CONTROL_PIN_TTL = 'statusControlPinTTL';



// WEBPACK FOOTER //
// ./src/AAF/Resilence/TTLConstants.js